import React from "react";
import PropTypes from "prop-types";

// Components
import { Button } from "react-bootstrap";

export const TextStyleSelection = ({
  activeBold = false,
  activeItalic = false,
  handleChangeFontStyle,
  textName,
}) => (
  <>
    <Button
      variant={activeBold ? "dark" : ""}
      onClick={handleChangeFontStyle}
      className="text-selection font-weight-bold"
      data-testid={`selection-font-bold-${textName}`}
    >
      B
    </Button>
    <Button
      variant={activeItalic ? "dark" : ""}
      onClick={handleChangeFontStyle}
      className="font-italic text-selection"
      data-testid={`selection-font-italic-${textName}`}
    >
      i
    </Button>
  </>
);

TextStyleSelection.propTypes = {
  activeBold: PropTypes.bool,
  activeItalic: PropTypes.bool,
  handleChangeFontStyle: PropTypes.func.isRequired,
  textName: PropTypes.string.isRequired,
};
